import { ALLOWED_TERMS_TAGS } from './constants';

const ALLOWED = new Set(ALLOWED_TERMS_TAGS.map(t => t.toUpperCase()));

/**
 * Mirrors what e-Contract does to `additional_terms` on receipt: keep only the
 * allowlisted tags, strip every attribute, and for any other tag drop the tag
 * but keep its text. Running it here means the preview staff review — and what
 * we send — is exactly what survives on the other side.
 *
 * The result is rebuilt from scratch out of text nodes and attribute-less
 * allowlisted elements (never copied from the input), so it is also safe to
 * render with dangerouslySetInnerHTML.
 */
export function sanitizeTermsHtml(html) {
  if (!html || !String(html).trim()) return '';

  // DOMParser builds an inert document — nothing in the input is executed or loaded.
  const parsed = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  const out = document.createElement('div');

  const walk = (source, target) => {
    source.childNodes.forEach(child => {
      if (child.nodeType === Node.TEXT_NODE) {
        target.appendChild(document.createTextNode(child.textContent));
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        if (ALLOWED.has(child.tagName)) {
          const el = document.createElement(child.tagName.toLowerCase());
          target.appendChild(el);
          walk(child, el);
        } else {
          walk(child, target); // unwrap: drop the tag, keep its content
        }
      }
    });
  };

  walk(parsed.body, out);
  return out.innerHTML;
}
